import store from '@/store'
import { ElMessage as Message } from 'element-plus'

export function blobToBase64(blob) {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}

export function isImage(name) {
  const nameSuffix = name.substring(name.lastIndexOf('.') + 1)
  return !!nameSuffix.match(/png|jpg|jpeg|bmp|webp|gif|svg|ico/i)
}

export function isDoc(name) {
  const nameSuffix = name.substring(name.lastIndexOf('.') + 1)
  return !!nameSuffix.match(/doc|docx|ppt|pptx|pdf|txt|csv/i)
}

export function isCode(name) {
  const nameSuffix = name.substring(name.lastIndexOf('.') + 1)
  return !!nameSuffix.match(
    /js|py|java|ts|go|cpp|h|c|md|php|json|css|html|htm|less|sass|scss|rs|kt|swift|groovy|cs|sh|bash|zsh|bat|sql|xml|rb/i
  )
}

export function isExcel(name) {
  const nameSuffix = name.substring(name.lastIndexOf('.') + 1)
  return !!nameSuffix.match(/xlsx|xls|numbers/i)
}

export function transferFileSize(size) {
  if (!size) return '0B'
  var num = 1024
  if (size < num) return size + 'B'
  if (size < Math.pow(num, 2)) return Math.ceil((size / num) * 100) / 100 + 'KB'
  if (size < Math.pow(num, 3)) return Math.ceil((size / Math.pow(num, 2)) * 100) / 100 + 'MB'
  if (size < Math.pow(num, 4)) return Math.ceil((size / Math.pow(num, 3)) * 100) / 100 + 'G'
  return Math.ceil((size / Math.pow(num, 4)) * 100) / 100 + 'T'
}

export function getFileIcon(type) {
  if (type === 'xlsx' || type === 'xls' || type === 'numbers') {
    return require('@/assets/image/common/excel.png')
  } else if (type === 'pdf') {
    return require('@/assets/image/common/pdf.png')
  } else if (type.match(/ppt|pptx|key/gim)) {
    return require('@/assets/image/common/ppt.png')
  } else if (type.match(/txt|doc|docx/gim)) {
    return require('@/assets/image/common/wendang.png')
  } else {
    return require('@/assets/image/common/file-default.png')
  }
}

export function adownload(url) {
  console.log(url)
  return new Promise((resolve, reject) => {
    try {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.download = 'xx'
      a.href = url + '?response-content-type=application/octet-stream'
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      resolve()
    } catch (error) {
      console.log(error)
      reject(error)
    }
  })
}

export function downloadWithProgress(file, index) {
  console.log(file, index)
  const { url } = file
  const xhr = new XMLHttpRequest()
  store.commit('CloudKnowledge/SET_FILE_UPLOADED', {
    index,
    val: { download: true, xhr }
  })
  xhr.open('GET', url, true)
  xhr.responseType = 'blob'
  xhr.onload = function () {
    if (xhr.status === 200) {
      const blob = xhr.response
      const a = document.createElement('a')
      a.style.display = 'none'
      a.download = file.wholeName
      a.href = URL.createObjectURL(blob)
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
  xhr.onprogress = function (event) {
    if (event.lengthComputable) {
      const percent = parseFloat(((event.loaded / event.total) * 100).toFixed(2))
      store.commit('CloudKnowledge/SET_FILE_UPLOADED', {
        index,
        val: {
          downloadPercent: percent
        }
      })
      if (percent === 100) {
        setTimeout(() => {
          store.commit('CloudKnowledge/SET_FILE_UPLOADED', {
            index,
            val: {
              xhr: null,
              download: false,
              downloadPercent: 0
            }
          })
        }, 800)
      }
    }
  }
  xhr.onerror = function (e) {
    Message('下载失败')
    store.commit('CloudKnowledge/SET_FILE_UPLOADED', {
      index,
      val: {
        xhr: null,
        download: false,
        downloadPercent: 0
      }
    })
  }
  xhr.send()
}
